import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@quest/ui/components/dialog";
import { Icon } from "@iconify/react";
import { Button } from "@quest/ui/components/button";

import { useTranslation } from "react-i18next";
import { useSubscribe } from "@/libs/hooks/use-subscribe";

interface AllowNotificationsProps {
  notificationPermissionPopup: boolean;
  setNotificationPermissionPopup: (value: boolean) => void;
  onPermissionChange?: () => void;
}

function AllowNotifications(props: AllowNotificationsProps) {
  const {
    notificationPermissionPopup,
    setNotificationPermissionPopup,
    onPermissionChange,
  } = props;

  const { t } = useTranslation("Common");

  const { subscribeUserToPush } = useSubscribe();

  const handleNotificationPermissionYes = () => {
    localStorage.setItem("notificationPermission", "granted");
    setNotificationPermissionPopup(false);
    // Request permission - this will show Chrome's native "Allow" and "Block" prompt
    Notification.requestPermission().then((permission) => {
      // If the user accepts, let's subscribe to push
      if (permission === "granted") {
        subscribeUserToPush();
      }
      // Notify parent component that permission has changed
      onPermissionChange?.();
    });
  };

  const handleNotificationPermissionNo = () => {
    localStorage.setItem("notificationPermission", "denied");
    setNotificationPermissionPopup(false);
  };
  return (
    <Dialog
      open={notificationPermissionPopup}
      onOpenChange={setNotificationPermissionPopup}
    >
      <DialogContent
        className="rounded-lg bg-white max-w-md"
        showCloseButton={false}
      >
        <DialogHeader>
          <DialogTitle>
            <div className="flex flex-col items-center gap-4">
              <div className="bg-blue-100 rounded-full p-4">
                <Icon
                  icon="lucide:bell"
                  width="32"
                  height="32"
                  className="text-blue-600"
                />
              </div>
            </div>
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4 pb-4">
          <div className="text-center">
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              {t("doYouWantToReceiveNotifications")}
            </h2>
          </div>
          <div className="flex gap-3 w-full">
            <Button
              onClick={handleNotificationPermissionYes}
              data-testid="allow-notifications-yes-button"
              className="rounded-md bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 flex-1"
            >
              {t("yes")}
            </Button>
            <Button
              onClick={handleNotificationPermissionNo}
              data-testid="allow-notifications-no-button"
              variant="outline"
              className="rounded-md border-gray-300 hover:bg-gray-50 text-gray-700 px-6 py-2 flex-1"
            >
              {t("no")}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default AllowNotifications;
